export default {"src":"/_next/static/media/mastercard-payment-logo.e9662adc.svg","height":25,"width":40,"blurWidth":0,"blurHeight":0};